import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';
import { frontendStateLeftSidebarOpenedMapToolSelector } from '~/store/frontendState/leftSidebar/leftSidebar.selectors';

export const isDataLayerToolActiveSelector = (state: AppState) =>
  frontendStateLeftSidebarOpenedMapToolSelector(state) === MapTool.DataLayers;

export const useIsDataLayerToolActiveSelector = () => useSelector(isDataLayerToolActiveSelector);
